(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var section = document.querySelector(".showreel");
    var media = document.querySelector(".showreel__media");
    var video = document.querySelector(".showreel__video");
    if (!section || !media) {
      return;
    }

    if (video) {
      video.play().catch(function () {});
    }

    var setupMobilePlaybackGuard = function () {
      if (!video) {
        return null;
      }
      if (video.dataset.showreelGuardReady === "true") {
        return null;
      }
      video.dataset.showreelGuardReady = "true";

      var isVisible = true;
      var resumeInterval = null;
      var scrollTriggerInstance = null;
      var observer = null;

      var requestPlay = function () {
        if (!video || document.hidden || !isVisible) {
          return;
        }
        if (!video.paused && !video.ended) {
          return;
        }
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      };

      var pauseVideo = function () {
        if (video && !video.paused) {
          video.pause();
        }
      };

      var startResumeWatch = function () {
        if (resumeInterval) {
          return;
        }
        resumeInterval = window.setInterval(function () {
          if (!isVisible || document.hidden) {
            return;
          }
          if (video && (video.paused || video.ended)) {
            requestPlay();
          }
        }, 1500);
      };

      var stopResumeWatch = function () {
        if (resumeInterval) {
          window.clearInterval(resumeInterval);
          resumeInterval = null;
        }
      };

      var setVisibleState = function (nextValue) {
        if (isVisible === nextValue) {
          return;
        }
        isVisible = nextValue;
        if (isVisible) {
          requestPlay();
          startResumeWatch();
        } else {
          stopResumeWatch();
          pauseVideo();
        }
      };

      var handlePlaybackIssue = function () {
        if (!isVisible || document.hidden) {
          return;
        }
        requestPlay();
      };

      var handleVisibilityChange = function () {
        if (document.hidden) {
          pauseVideo();
          return;
        }
        if (isVisible) {
          requestPlay();
          startResumeWatch();
        }
      };

      video.addEventListener("pause", handlePlaybackIssue);
      video.addEventListener("ended", handlePlaybackIssue);
      video.addEventListener("stalled", handlePlaybackIssue);
      video.addEventListener("waiting", handlePlaybackIssue);
      video.addEventListener("suspend", handlePlaybackIssue);
      document.addEventListener("visibilitychange", handleVisibilityChange);

      if (window.ScrollTrigger) {
        var triggerOptions = {
          trigger: section || video,
          start: "top 80%",
          end: "bottom top",
          invalidateOnRefresh: true,
          onEnter: function () {
            setVisibleState(true);
          },
          onEnterBack: function () {
            setVisibleState(true);
          },
          onLeave: function () {
            setVisibleState(false);
          },
          onLeaveBack: function () {
            setVisibleState(false);
          }
        };

        if (window.DNB && window.DNB.scroller) {
          triggerOptions.scroller = window.DNB.scroller;
        }

        scrollTriggerInstance = window.ScrollTrigger.create(triggerOptions);
      } else if (window.IntersectionObserver) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.target !== section && entry.target !== video) {
                return;
              }
              setVisibleState(entry.isIntersecting && entry.intersectionRatio > 0.2);
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(section || video);
      }

      requestPlay();
      startResumeWatch();

      return function () {
        stopResumeWatch();
        pauseVideo();
        if (scrollTriggerInstance) {
          scrollTriggerInstance.kill();
        }
        if (observer) {
          observer.disconnect();
        }
        video.removeEventListener("pause", handlePlaybackIssue);
        video.removeEventListener("ended", handlePlaybackIssue);
        video.removeEventListener("stalled", handlePlaybackIssue);
        video.removeEventListener("waiting", handlePlaybackIssue);
        video.removeEventListener("suspend", handlePlaybackIssue);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        delete video.dataset.showreelGuardReady;
      };
    };

    var mobileQuery = window.matchMedia ? window.matchMedia("(max-width: 640px)") : null;
    var mobileCleanup = null;
    var updateMobileGuard = function () {
      if (!mobileQuery) {
        return;
      }
      if (mobileQuery.matches) {
        if (!mobileCleanup) {
          mobileCleanup = setupMobilePlaybackGuard();
        }
      } else if (mobileCleanup) {
        mobileCleanup();
        mobileCleanup = null;
      }
    };

    if (mobileQuery) {
      updateMobileGuard();
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener("change", updateMobileGuard);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(updateMobileGuard);
      }
    }
    //İlk açılışta videonun oynatılması kapalı / mouse ile üzerine gelince oynatılacak şekilde ayarland -- İPTAL
    // if (video) {
    //   video.addEventListener("mouseenter", function () {
    //     video.play().catch(function () {});
    //   });
    //   video.addEventListener("mouseleave", function () {
    //     video.pause();
    //   });
    // }

    if (!window.gsap || !window.ScrollTrigger) {
      return;
    }

    var baseWidth = 400;
    var baseHeight = 225;

    var mm = window.gsap.matchMedia();

    mm.add("(min-width: 641px)", function () {
      var triggerOptions = {
        trigger: section,
        start: "top bottom",
        end: "+=100%",
        scrub: true,
        pin: media,
        pinSpacing: false,
        anticipatePin: 1,
        invalidateOnRefresh: true
      };

      if (window.DNB.scroller) {
        triggerOptions.scroller = window.DNB.scroller;
      }

      var timeline = window.gsap.timeline({ scrollTrigger: triggerOptions });
      timeline.fromTo(
        media,
        {
          x: function () {
            return (window.innerWidth - baseWidth - 40);
          },
          y: function () {
            return -(window.innerHeight + 40);
          },
          scaleX: 1,
          scaleY: 1,
          width: baseWidth,
          height: baseHeight,
          borderRadius: 2
        },
        {
          x: function () {
            return (window.innerWidth - baseWidth);
          },
          y: function () {
            return -(window.innerHeight);
          },
          scaleX: function () {
            return window.innerWidth / baseWidth;
          },
          scaleY: function () {
            return window.innerHeight / baseHeight;
          },
          width: window.innerWidth,
          height: window.innerHeight,
          borderRadius: 0,
          ease: "none",
          duration: 0.5
        }
      );
      timeline.to(media, {
        x: function () {
          return (window.innerWidth - baseWidth);
        },
        y: function () {
          return -(window.innerHeight);
        },
        scaleX: function () {
          return window.innerWidth / baseWidth;
        },
        scaleY: function () {
          return window.innerHeight / baseHeight;
        },
        width: window.innerWidth,
        height: window.innerHeight,
        borderRadius: 0,
        ease: "none",
        duration: 0.5
      });

      return function () {
        timeline.kill();
        if (timeline.scrollTrigger) {
          timeline.scrollTrigger.kill();
        }
      };
    });

    mm.add("(max-width: 640px)", function () {
      window.gsap.set(media, { clearProps: "all" });
      return function () {
        window.gsap.set(media, { clearProps: "all" });
      };
    });
  });
})();
